'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BeaconEntryQueue = function () {
    function BeaconEntryQueue() {
        var _this = this;

        _classCallCheck(this, BeaconEntryQueue);

        this.data = {};
        ['clearBeaconEntryQueue', 'getBeaconEntryQueue', 'getEntry', 'queueBeaconEntry', 'setEntry'].forEach(function (method) {
            _this[method] = _this[method].bind(_this);
        });
    }

    _createClass(BeaconEntryQueue, [{
        key: 'getEntry',
        value: function getEntry(name) {
            return this.data[name];
        }
    }, {
        key: 'setEntry',
        value: function setEntry(name) {
            var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this.data[name] = val;
        }
    }, {
        key: 'getBeaconEntryQueue',
        value: function getBeaconEntryQueue() {
            return Object.keys(this.data);
        }
    }, {
        key: 'queueBeaconEntry',
        value: function queueBeaconEntry(names) {
            var _this2 = this;

            if (Array.isArray(names)) {
                names.forEach(function (name) {
                    _this2.setEntry(name);
                });
            } else if (names) {
                this.setEntry(names);
            }
        }
    }, {
        key: 'clearBeaconEntryQueue',
        value: function clearBeaconEntryQueue() {
            this.data = {};
        }
    }]);

    return BeaconEntryQueue;
}();

exports.default = BeaconEntryQueue;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/BeaconEntryQueue.js
// module id = 510
// module chunks = 5